import React, { useRef } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import styles from "./SimilarProducts.module.css";
import ProductCard from "../ProductCard/ProductCard";
import { Product } from "../Types/product.types";
import { Toast } from "primereact/toast";

interface SimilarProductsProps {
  title?: string;
  subtitle?: string;
  products: Product[];

  // product: string;
  onAddToCart?: (product: Product) => void;
}

const SCROLL_AMOUNT = 900;

const SimilarProducts: React.FC<SimilarProductsProps> = ({
  title = "Similar High-Performance Tyres",
  subtitle = "Explore other options in the same category",
  products,
  onAddToCart,
}) => {
  const toastRef = useRef<Toast>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  if (!products?.length) return null;
  const scroll = (direction: "left" | "right") => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left:
        direction === "left"
          ? -scrollRef.current.clientWidth
          : scrollRef.current.clientWidth,
      behavior: "smooth",
    });
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div>
          <h2 className={styles.heading}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        <div className={styles.navBtns}>
          <button
            type="button"
            className={styles.navBtn}
            onClick={() => scroll("left")}
            aria-label="Scroll left"
          >
            <FiChevronLeft size={22} />
          </button>
          <button
            type="button"
            className={styles.navBtn}
            onClick={() => scroll("right")}
            aria-label="Scroll right"
          >
            <FiChevronRight size={22} />
          </button>
        </div>
      </div>

      <div className={styles.track} ref={scrollRef}>
        {products.map((product) => (
          <div className={styles.slide} key={product.product_id}>
            <ProductCard product={product} toastRef={toastRef} similar={true} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarProducts;
